import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.RequestOnHoldInfo', {
    description: 'NOTE: This request is on hold. In order to make a decision, please click on the “Unlock” button.',
});
